import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import HotNine from "./components/HotNine";
import ShotGallery from "./components/ShotGallery";
import AlertsFeed from "./components/AlertsFeed";
import FeatureSection from "./components/FeatureSection";
import TopicSection from "./components/TopicSection";
import GuideSection from "./components/GuideSection";
import FaqSection from "./components/FaqSection";
import SubscribeSection from "./components/SubscribeSection";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-[#fbf6ec]">
      <Navbar />
      <main>
        <HeroSection />
        <HotNine />
        <ShotGallery />
        <AlertsFeed />
        <FeatureSection />
        <TopicSection />
        <GuideSection />
        <FaqSection />
        <SubscribeSection />
      </main>
      <Footer />
    </div>
  );
}